import { render, staticRenderFns } from "./ModalWorkflowConfiguracao.vue?vue&type=template&id=03e35946&scoped=true"
import script from "./ModalWorkflowConfiguracao.vue?vue&type=script&lang=js"
export * from "./ModalWorkflowConfiguracao.vue?vue&type=script&lang=js"
import style0 from "./ModalWorkflowConfiguracao.vue?vue&type=style&index=0&id=03e35946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e35946",
  null
  
)

export default component.exports